import * as allergens from './list'

export const allAllergens = Object.values(allergens).sort(
    (previous, current) => previous.priority - current.priority,
)
